import { useTranslation } from 'react-i18next'
import { useContextSelector } from 'use-context-selector'

import useTabContext from '../../lib/hooks/useTabContext'
import { AppContext } from '../AppState'
import Button from '../Button'
import { getContactBadge, getTalentTransferBadge, showTabBarRoutes } from '../TabBar'
import './style.scss'

const links = [
    'home',
    'profile',
    'marketplace',
    'inbox',
    'playlists',
]

/**
 * Auf dem Desktop gibt es keine Tab-Leiste — dieses Menue traegt dieselben
 * Ziele. Die Beschriftungen kommen aus denselben Schluesseln; nur "Postfach"
 * ist neu und braucht deshalb einen mitgelieferten Text, solange der
 * Uebersetzungsdienst ihn noch nicht kennt.
 */
const LABEL_FALLBACKS: Record<string, string> = {
    inbox: 'Postfach',
}

const DesktopMenu: React.FC = () => {
    const { t } = useTranslation()
    const activeUrl = useTabContext()

    const { newForeignActivities, pendingTalentTransferRequests, pendingContactRequests, unreadContactMessages } = useContextSelector(AppContext, state => state.state)
    if (!showTabBarRoutes.includes(`/${activeUrl}`)) return null

    return (
        <div
            className='desktop-menu'
        >
            { links.map(link => {
                const badge = (() => {
                    switch (link) {
                        // Dieselbe Regel wie in der Tab-Leiste: Die Zahl zaehlt
                        // nur, worauf jemand eine Antwort erwartet.
                        case 'inbox': return getContactBadge(pendingContactRequests, unreadContactMessages)
                        case 'profile': return getTalentTransferBadge(pendingTalentTransferRequests)
                        default: return undefined
                    }
                })()

                return (
                    <Button
                        key={link}
                        className='ion-margin-horizontal'
                        fill='clear'
                        color={activeUrl === link ? 'secondary' : undefined}
                        routerLink={`/${link}`}
                        routerOptions={{ unmount: true }}
                        badge={badge}
                        dot={link === 'inbox' && (newForeignActivities?.length ?? 0) > 0}
                    >
                        {t(`tabbar.${link}`, LABEL_FALLBACKS[link])}
                    </Button>
                )
            })}
            {/*
              * Hier stand ein Knopf nach https://backoffice.joinmytalent.com/teams.
              * Das Backoffice ist eine eigene Next.js-Anwendung (Ordner
              * `backoffice`, letzter Stand Februar 2024), die als pm2-Prozess
              * auf 127.0.0.1:3006 laufen sollte. Dort lauscht nichts mehr, der
              * Reverse Proxy antwortet auf jedem Pfad mit 502 — der Knopf fuehrte
              * also ins Leere. Ausserdem war es ein `href` statt `Browser.open`
              * und haette im nativen Build die Webview aus der App getragen.
              *
              * Kommt das Backoffice zurueck, gehoert der Knopf wieder her —
              * dann aber ueber `Browser.open`, wie die Links im Burgermenue.
              */}
        </div>
    )
}

export default DesktopMenu
